<template>
  <div
    :class="{ 'isEnhanced': result.enhanced }"
    class="Search Search--employers"
  >
    <div :class="[{ 'isFeatured': featured }, 'Search-content']">
      <figure class="Search-companyLogo">
        <a
          :href="result.profile_url"
          :title="result.name + ' profile link'"
          class="company-search-logo"
        >
          <img
            v-if="result.small_logo"
            :src="result.small_logo"
            :alt="result.name"
            width="58"
            height="58"
            loading="lazy"
          >
          <img
            v-else
            :src="defaultLogo"
            :alt="result.name"
            width="58"
            height="58"
            loading="lazy"
          >
        </a>
      </figure>
      <div class="Search-descriptions">
        <a
          :href="result.profile_url"
          :title="result.name + ' profile link'"
        >
          <h2 class="Job-titleHeader">{{ result.name }}</h2>
        </a>

        <ul class="Search-links">
          <li v-if="result.jobs_url">
            <a
              :href="result.jobs_url"
              :title="result.name + ' jobs link'"
            >
              View Jobs
            </a>
          </li>
          <li v-if="result.reviews_url">
            <a
              :href="result.reviews_url"
              :title="result.name + ' reviews link'"
            >
              View Reviews
            </a>
          </li>
        </ul>

        <div
          v-if="result.is_ted && result.ted_details.paid"
          class="Search-ted"
        >
          <tooltip>
            <template #trigger>
              <span
                class="Tag Tag--purple Tag--small"
              ><i class="far fa-trophy" /> {{ result.ted_label }}</span>
            </template>
            <template #tip>
              <span> {{ tooltipForTopEmployer }}</span>
            </template>
          </tooltip>
        </div>
      </div>
      <div class="Search-buttons">
        <a
          :href="result.profile_url"
          :title="result.name + ' profile link'"
          class="Button Button--primary"
        >
          View Profile
        </a>
        <div class="icon-cta">
          <save-item-button
            :id="result.id"
            :company-id="result.id"
            :company-name="result.name"
            :title="result.name"
            :url="result.profile_url"
            type="companies"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SaveItemButton from '@/components/common/save-item-button.vue';
import Tooltip from '../../common/rmp-tool-tip.vue';

export default {
  name: 'CompanyResult',
  components: {
    SaveItemButton,
    tooltip: Tooltip,
  },

  props: {
    result: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    featured: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('entities', {
      getCdnImagePath: 'getCdnImagePath',
    }),
    tooltipForTopEmployer() {
      return `${this.result.ted_details.rank_ordinal} in ${this.result.ted_details.type_of_rank_name} table`;
    },
    defaultLogo() {
      return this.getCdnImagePath('/website/company_placeholder.jpg');
    },
  },
};
</script>

<style lang="scss" scoped>
    .SearchResult-wrapper {
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #d1d1d1;
    }

    .SearchResult-review {
        display: flex;
        align-content: space-between;

    }

    .SearchResult-reviewLogo {
        flex: 0 0 75px;
        margin-right: 30px;

        img {
            width: 75px;
        }
    }

    .SearchResult-reviewContent {
        flex: 1;

        ul {
            margin-bottom: 0;
            list-style-type: none;
            display: flex;
        }
        li {
            margin-right: 10px;
        }
    }

    .SearchResult-reviewTitle {
        font-size: 18px;
        margin: 0;
    }

    .SearchResult-reviewQuote {
        margin-bottom: 0;
    }

    .SearchResult-shortlist {
        flex: 0 0 50px;
        text-align: right;
    }

    .SearchResult-reviewRatingScore {
        padding: 5px;
        background: #d1d1d1;
    }
</style>
